import { Component } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { AuthService } from '@shared/services/auth.service'
import { ToastService } from '../../services/toast.service'
import { Router } from '@angular/router'

@Component({
  selector: 'app-forgotten-password',
  templateUrl: './forgotten-password.component.html',
  styleUrls: ['./forgotten-password.component.scss'],
})
export class ForgottenPasswordComponent {
  pageTitle = 'Elfelejtett jelszó'
  forgottenPasswordForm: FormGroup

  constructor(private authService: AuthService, private toastService: ToastService, private router: Router) {
    this.forgottenPasswordForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    })
  }

  onSubmit(): void {
    if (this.forgottenPasswordForm.invalid) {
      return
    }

    const email = this.forgottenPasswordForm.value.email
    this.authService
      .sendPasswordResetEmail(email, 'http://localhost:4200/reset-password')
      .then(() => {
        this.toastService.showSuccess('Email elküldve. Kérjük ellenőrizd a postafiókod.')
        console.log('Missing feature: handle post-send behavior (e.g. navigate to login)')
      })
      .catch(error => {
        console.error('Password reset email error:', error)
        this.toastService.showError('Hiba történt a jelszó visszaállítási email küldésekor.')
      })
  }
}
